import "./tasks.css";


export default function AppTasks ({}) {

    return (
        <div className="tasks-continer">
            <div>
                <p>תזכורת</p>
            </div>
            
            <div>
                
            </div>
        </div>
    )
}